module.exports = __webpack_public_path__ + "img/building-line.543c15d9.svg";